import { ReactNode, useState } from "react";
import type Stitches from "@stitches/react";
import {
  ActionBanner as ActionBannerStyledComponent,
  BannerActions,
} from "./__styles__/ActionBanner";
import { BANNER_TYPES } from "./__styles__/Banner";
import { BannerItem } from "./Banner";
import { ActionButton } from "./Buttons/ActionButton";
import { Button } from "./Buttons/Button";

export interface ActionBannerProps extends Stitches.VariantProps<
  typeof ActionBannerStyledComponent
> {
  children?: ReactNode;
  loading?: boolean;
  type?: BANNER_TYPES;
  downloadButtonUrl?: string;
  downloadButtonText?: string;
  dismissButton?: boolean;
  onDismiss?: () => void;
}

const ActionBanner = ({
  children,
  type = BANNER_TYPES.INFO,
  loading,
  downloadButtonUrl,
  downloadButtonText = "Download",
  dismissButton,
  onDismiss,
}: ActionBannerProps) => {
  const [isHidden, setIsHidden] = useState(false);

  const handleDismiss = () => {
    setIsHidden(true);
    onDismiss?.();
  };

  if (isHidden) {
    return null;
  }

  return (
    <ActionBannerStyledComponent type={type}>
      <BannerItem loading={loading} type={type}>
        {children}
      </BannerItem>

      <BannerActions>
        {downloadButtonUrl && (
          <Button
            size="small"
            variant="secondary"
            onPress={() => window.open(downloadButtonUrl, "_blank")}
            title={downloadButtonText}
          />
        )}

        {dismissButton && (
          <ActionButton icon="x" onClick={handleDismiss} aria-label="Dismiss" />
        )}
      </BannerActions>
    </ActionBannerStyledComponent>
  );
};

export default ActionBanner;
